import React from "react";
import './Style/experiment.css'
const Modules = () => {
    return(
        <>
            <div className="Body" id="ExperimentsB">
                <h6 className="text-center">Nothing to Show here. <br />Will be updated soon.</h6>
            </div>
        </>
    )
} 

export { Modules }